import React from "react"
import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { MenuItem } from "components/dialogs/Menu"
import { asNumber } from "utilities/strings"
import { TABULAR_NUMS_SX } from "../../FilterIcon"

type Props = {
  label: string;
  count: number | null;
  onSelect: () => void;
  icon?: string;
  iconColor?: string;
  selected?: boolean;
}

const Filter = ({
  label, count, onSelect, icon = "dot", iconColor, selected,
}: Props) => (
  <MenuItem
    onClick={onSelect}
    fontSize="md"
    bg={selected ? "blue.50" : undefined}
    px={4}
    py={2.5}
  >
    <Flex align="center" justify="space-between" w="full">
      <Flex align="center" overflow="hidden" mr={4}>
        <Icon icon={icon} size={["dot", "circle"].includes(icon) ? 3 : 4} mr={2} flexShrink={0} color={iconColor} />
        <Text isTruncated>{label}</Text>
      </Flex>
      <Text as="span" flexShrink={0} sx={TABULAR_NUMS_SX}>
        {count === null ? "–" : asNumber(count)}
      </Text>
    </Flex>
  </MenuItem>
)

export default Filter
